import Psa from '@/models/Psa.model';

export const checkForAccountOverride = (psaData: Psa | undefined): boolean =>
  psaData
    ? psaData?.psa?.partialPlanTermination ||
      psaData?.psa?.historicalYearsOfVesting > 0 ||
      !!psaData?.psa?.yearsOfVesting
    : false;
